import apiClient from './apiClient'

export interface Announcement {
  sa_id: number
  announcement_topic: string
  announcement_description: string
  start_date: string
  end_date?: string
  is_read?: number | null
}

export interface AnnouncementsResponse {
  success?: boolean
  data: Announcement[]
  total?: number
}

/**
 * Fetch system announcements for the user drawer (matches Angular loadannouncementupdates).
 */
export async function fetchSystemAnnouncements(): Promise<AnnouncementsResponse> {
  const response = await apiClient.get<AnnouncementsResponse>('/api/system_announcements', {
    params: {
      sortBy: 'desc',
      orderBy: 'start_date',
      type: true,
      fromPage: 'sidebar',
    },
  })

  return response.data
}

/**
 * Mark a system announcement as read (matches Angular announcementMarkRead).
 */
export async function markAnnouncementRead(saId: number, isRead = 1): Promise<void> {
  await apiClient.post(`/api/notification/${saId}`, { is_read: isRead })
}
